/**
 * Prova a parsare una stringa in int rimuovendo i punti
 * @param value
 * @returns
 */
export const parseIntNumberWithPoints = (value: string) => {
    return typeof value === 'string' && value.indexOf('.') > -1
        ? parseInt(value.replace(/\./g, ''))
        : parseInt(value);
};
